import { isFunction } from 'swipeclock-frontend';
import { PUNCH_WARNING_TIMEOUT_MS } from '../constants/punchSubmitTimeoutConstants';

export async function awaitWithPunchWarning(promise, onWarningTimeout) {
  let settled = false;
  const timeoutId = setTimeout(() => {
    if (!settled && isFunction(onWarningTimeout)) {
      onWarningTimeout();
    }
  }, PUNCH_WARNING_TIMEOUT_MS);

  try {
    return await promise;
  } finally {
    settled = true;
    clearTimeout(timeoutId);
  }
}
